export const resumeData = state => state.data;



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/resume/getters.js
 **/